import { useEffect } from "react";
const usePreventScroll = (options = {}) => {
  const { isDisabled, restoreScrollPosition = false } = options;
  useEffect(() => {
    const { overflow, position, height, width } = document.body.style;
    const { scrollX, scrollY } = window;
    if (!isDisabled) {
      Object.assign(document.body.style, {
        overflow: "hidden",
        position: "fixed",
        height: "100vh",
        width: "100vw"
      });
    }
    return () => {
      Object.assign(document.body.style, {
        overflow,
        position,
        width,
        height
      });
      if (restoreScrollPosition && (scrollX !== 0 || scrollY !== 0)) {
        window.scrollTo(scrollX, scrollY);
      }
    };
  }, [isDisabled, restoreScrollPosition]);
};
var usePreventScroll_default = usePreventScroll;
export {
  usePreventScroll_default as default
};
